// extracted by mini-css-extract-plugin
export default {"wrapper":"PagePlayers_wrapper__nzAy4","form":"PagePlayers_form__W9-0H","form__input":"PagePlayers_form__input__u5vCT","form__button":"PagePlayers_form__button__j9u-r"};